import { getSocialAuthServiceConfigs } from "./../social.auth.helper";
var ɵ0 = getSocialAuthServiceConfigs;
var PfSocialLoginModule = /** @class */ (function () {
    function PfSocialLoginModule() {
    }
    return PfSocialLoginModule;
}());
export { PfSocialLoginModule };
export { ɵ0 };
